import * as React from 'react'

function SvgLogOut(props, svgRef) {
  return (
    <svg viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path d="M19.723 8.295l-6.667 6.667c-.595.595-1.627.178-1.627-.675v-3.81H6.032a.95.95 0 01-.952-.952v-3.81a.95.95 0 01.952-.952h5.397V.953c0-.849 1.028-1.27 1.627-.674l6.667 6.667a.96.96 0 010 1.349zM7.62 14.764v-1.588a.478.478 0 00-.476-.476H3.81c-.703 0-1.27-.568-1.27-1.27V3.81c0-.702.567-1.27 1.27-1.27h3.333a.478.478 0 00.476-.476V.477a.478.478 0 00-.476-.476H3.81A3.81 3.81 0 000 3.81v7.619a3.81 3.81 0 003.81 3.81h3.333a.478.478 0 00.476-.476z" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgLogOut)
export default ForwardRef
